export enum AnimationType {
  Slide = 'slide',
  SlideUp = 'slideUp',
  SlideExtend = 'slideExtend',
  Fade = 'fade',
}
